/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/datalab-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export const DatalabExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    notebookName: {
      type: 'string',
      title: 'Notebook path',
      description: 'Path of the notebook. Hint: Copy path to clipboard in datalab copies the filename.',
      pattern: '\\.ipynb$'
    },
    workbook: {
      anyOf: [{
        type: 'object',
        properties: {
          language: {
            type: 'string',
            enum: ['Python'],
            title: 'Language',
            description: 'The language of the workbook',
            default: 'Python'
          },
          languageVersion: {
            type: 'string',
            enum: ['3.8', '3.10'],
            title: 'Language version',
            description: 'The version of the language in the workbook',
            default: '3.10'
          }
        },
        required: ['language', 'languageVersion'],
        title: 'Python workbook'
      }, {
        type: 'object',
        properties: {
          language: {
            type: 'string',
            enum: ['R'],
            title: 'Language',
            description: 'The language of the workbook',
            default: 'R'
          },
          languageVersion: {
            type: 'string',
            enum: ['4.2', '4.4'],
            title: 'Language version',
            description: 'The version of the language in the workbook',
            default: '4.4'
          }
        },
        required: ['language', 'languageVersion'],
        title: 'R workbook'
      }],
      title: 'Workbook type',
      description: 'The type of workbook.'
    },
    successMessage: {
      type: 'string',
      title: 'Success message',
      description: 'The message to display when the exercise is successfully completed'
    },
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    sct: {
      type: 'string',
      default: ''
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    solution: {
      type: 'string',
      default: ''
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'hint', 'instructions', 'notebookName', 'sct', 'solution', 'successMessage', 'title', 'workbook', 'xp'],
  definitions: {}
};
export const isValidDatalabExerciseV0 = createValidator(DatalabExerciseV0Schema);
export const DatalabExerciseV0Definition = {
  schema: DatalabExerciseV0Schema,
  validate: isValidDatalabExerciseV0
};